import { responseTypes } from "@/modules";
const secret: string | undefined = "REGsFVDOa242#@#$@$%GFS";
import CryptoJs from 'crypto-js'

export const Encrypt = async (data: string): Promise<responseTypes> => {
    try {
        if (!secret) {
            return { success: false, message: 'No secret is found!, please contact out dev!', data: "" }
        }
        const encs = await CryptoJs.AES.encrypt(data, secret).toString();
        return { success: true, message: "", data: encs }
    } catch (error) {
        console.log(error);
        return { success: false, message: 'Error in encryption!', data: "" }
    }
}

export const Decrypt = async (encryptedString: string): Promise<responseTypes> => {
    try {
        if (!secret) {
            return { success: false, message: 'No secret is found!, please contact out dev!', data: "" }
        }
        const dec = await CryptoJs.AES.decrypt(encryptedString, secret);
        let dec2 = await dec.toString(CryptoJs.enc.Utf8);
        return { success: true, message: "", data: dec2 }
    } catch (error) {
        console.log(error);
        return { success: false, message: 'Error in decryption!', data: "" }
    }
}